module.exports = __webpack_public_path__ + "img/sb_mccb.18eac678.png";